var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseChip',{staticClass:"base-value-tag",attrs:{"size":"sm","tone":"info","preset":"soft","clearable":_vm.isClearable,"selected":_vm.selected},on:{"click":_vm.valueClicked,"clear":_vm.deleteValue}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }